import type { PlaceKind } from '../types/program';

/** Paths that must not be used as a subject slug. */
export const RESERVED_SLUGS = new Set([
  'resources',
  'toolkits',
  'references',
  'events',
  'report',
  'search',
  'about',
  'contact',
  'glossary',
  'order-resources',
  'admin',
  'page',
  'privacy',
  'terms',
  'careers',
  'useful-links',
  'sso-callback',
  'design',
  'library',
  'dashboard',
  'profile',
  'data',
  'elearning',
]);

export function subjectPath(slug: string): string {
  return `/${slug}`;
}

export function referencePath(slug: string): string {
  return `/references/${slug}`;
}

export function placePath(place: { slug: string; kind?: PlaceKind | string | null }): string {
  return place.kind === 'REFERENCE' ? referencePath(place.slug) : subjectPath(place.slug);
}

export function toolkitPath(hub: { slug: string; program?: { slug: string } | null }): string {
  return hub.program?.slug ? `/${hub.program.slug}/${hub.slug}` : `/toolkits/${hub.slug}`;
}
